import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        title: ["Certifications (to be removed).", "Сертификаты (будет удалено)."][index],
        subtitle: [
            "This section will be removed soon. Please use the one above.",
            "Этот раздел скоро уберут. Используйте раздел выше.",
        ][index],
        placeholder: ["ID, Name", "ID, название"][index],
        addLabel: ["Add Certificate", "Добавить Сертификат"][index],
    };
};
